import map from "lodash/fp/map";
import remove from "lodash/fp/remove";
import assign from "lodash/fp/assign";

const getSource = (item) => assign({ _id: item._id }, item._source);

class DistrictsPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "District",
      state: "district",
      name: "district",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "City", name: "city" },
    ];

    this.filters = [
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "District",
        state: "district",
        size: 25,
      },
    ];
  }

  justify(data) {
    return map(getSource)(data);
  }

  justifyPolygon(data) {
    data = this.justify(data);
    const hasNoPolygon = (i) => !(i.loc && i.loc.coordinates);

    return remove(hasNoPolygon)(data);
  }
}

export default DistrictsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/districts/districts.transforms.js